// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"buttonGroup__AZKLb","content":"content__dINEH","button":"button__idwHc","tertiaryButton":"tertiaryButton__CRSLU"};